import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-ink text-paper border-t-2 border-ink" data-testid="main-footer">
      {/* Upper band */}
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-4 h-4 bg-signal border-2 border-paper" />
              <span className="font-archivo text-lg uppercase tracking-tight">Fit Print Bros</span>
            </div>
            <p className="font-inter text-sm text-paper/60 leading-relaxed">
              Professional custom printing. Screen printing, DTF, embroidery, stickers, signs & banners.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-mono text-[11px] uppercase tracking-[0.12em] font-bold text-acid mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/products" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Printing Services</Link></li>
              <li><Link to="/design-services" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Design Services</Link></li>
              <li><Link to="/event-packages" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Event Packages</Link></li>
              <li><Link to="/templates" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Design Templates</Link></li>
              <li><Link to="/concierge-quote" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Concierge Quote</Link></li>
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h3 className="font-mono text-[11px] uppercase tracking-[0.12em] font-bold text-acid mb-4">Tools</h3>
            <ul className="space-y-2">
              <li><Link to="/design-studio" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Design Studio</Link></li>
              <li><Link to="/my-designs" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">My Designs</Link></li>
              <li><Link to="/track" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Track Order</Link></li>
              <li><Link to="/cart" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Cart</Link></li>
            </ul>
          </div>

          {/* Info */}
          <div>
            <h3 className="font-mono text-[11px] uppercase tracking-[0.12em] font-bold text-acid mb-4">Info</h3>
            <ul className="space-y-2">
              <li><Link to="/faq" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">FAQ</Link></li>
              <li><Link to="/blog" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Blog</Link></li>
              <li><Link to="/reviews" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Reviews</Link></li>
              <li><Link to="/terms" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Terms</Link></li>
              <li><Link to="/privacy" className="font-inter text-sm text-paper/70 hover:text-acid transition-colors">Privacy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t-2 border-paper/20">
        <div className="max-w-[1280px] mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.12em] text-paper/40">
            &copy; {new Date().getFullYear()} Fit Print Bros. All rights reserved.
          </p>
          <div className="flex items-center gap-2">
            <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-paper/40">Professional Custom Printing</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
export default Footer;
